import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-45f8ea20")

_pushScopeId("data-v-45f8ea20")
const _hoisted_1 = { class: "center title-1" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "buttons-container" }
const _hoisted_5 = { class: "dossiers" }
const _hoisted_6 = {
  key: 0,
  class: "loader-container"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("dig-ui-loader", null, null, -1)
const _hoisted_8 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_simulations_search = _resolveComponent("simulations-search")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("dig-ui-title", _hoisted_1, [
      (!$setup.isAdmin)
        ? (_openBlock(), _createBlock("span", _hoisted_2, _toDisplayString($setup.t('mySimulations')), 1))
        : _createCommentVNode("", true),
      ($setup.isAdmin)
        ? (_openBlock(), _createBlock("span", _hoisted_3, _toDisplayString($setup.t('theSimulations')), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("dig-ui-standard-button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.goTo(`new-simulation`)))
      }, _toDisplayString($setup.t('newSimulation')), 1)
    ]),
    _createVNode("div", _hoisted_5, [
      (
        $setup.loading &&
          !$setup.storeSimulation.getters[$setup.StoreGettersSimulation.SIMULATIONS].length
      )
        ? (_openBlock(), _createBlock("div", _hoisted_6, [
            _hoisted_7
          ]))
        : _createCommentVNode("", true),
      (
        !$setup.loading ||
          $setup.storeSimulation.getters[$setup.StoreGettersSimulation.SIMULATIONS].length
      )
        ? (_openBlock(), _createBlock("div", _hoisted_8, [
            _createVNode(_component_simulations_search, {
              simulations: 
          $setup.storeSimulation.getters[$setup.StoreGettersSimulation.SIMULATIONS]
        
            }, null, 8, ["simulations"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
})